import type { Citation } from "@/data/citations";

export function SourcesList({
  sources,
  heading = "Sources & further reading",
  compact = false,
}: {
  sources: Citation[];
  heading?: string;
  compact?: boolean;
}) {
  if (sources.length === 0) return null;
  return (
    <section aria-label={heading} className={compact ? "mt-3" : "mt-12 rounded-2xl border border-border bg-card/40 p-5 sm:p-6"}>
      <h2 className={compact ? "text-xs font-semibold uppercase tracking-wider text-muted-foreground" : "font-display text-lg font-semibold text-foreground"}>
        {heading}
      </h2>
      <ol className={compact ? "mt-1.5 space-y-1 text-xs" : "mt-3 list-decimal space-y-2 ps-5 text-sm"}>
        {sources.map((s) => (
          <li key={s.url} className="text-muted-foreground">
            <a href={s.url} target="_blank" rel="noopener" className="text-primary underline underline-offset-2 hover:opacity-80">
              {s.title}
            </a>{" "}
            — {s.publisher}
          </li>
        ))}
      </ol>
      {!compact && (
        <p className="mt-3 text-xs text-muted-foreground">
          These sources are for general education. Recovery Trauma™ does not diagnose or treat — please speak to a qualified professional about your own situation.
        </p>
      )}
    </section>
  );
}
